import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalService
} from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { routes } from './app/app.routes';
import { O365AuthService } from './app/services/o365-auth.service';
import { ReferenceDataService } from './app/services/reference-data.service';


function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: environment.azureAd.clientAppId,
      authority: environment.azureAd.authority,
      redirectUri: environment.azureAd.redirectUri,
      postLogoutRedirectUri: environment.azureAd.logoutRedirectUri,
      // navigateToLoginRequestUrl: true 
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false
    }
  });
}

function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      [environment.api_url, ['api://' + environment.azureAd.apiAppId + "/" + environment.azureAd.apiScope]]
    ])
  };
}

function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['api://' + environment.azureAd.apiAppId + "/" + environment.azureAd.apiScope],
      prompt: 'select_account'
    },
    loginFailedRoute: '/welcome'
  };
}

async function main() {
  // Create the MSAL instance and initialize it before bootstrapping the app
  // This ensures that the instance is ready to handle redirects and other auth flows
  // before any components are rendered.
  const msalInstance = MSALInstanceFactory();
  await msalInstance.initialize();

  const extendedConfig = {
    ...appConfig,
    providers: [
      ...(appConfig.providers || []),
      ReferenceDataService,
      provideRouter(routes,
        withRouterConfig({
          onSameUrlNavigation: 'reload',
        }),
        withInMemoryScrolling({
          scrollPositionRestoration: 'enabled',
          anchorScrolling: 'enabled',
        })
      ),
      provideHttpClient(withInterceptorsFromDi()),

      MsalService,
      MsalBroadcastService,
      MsalGuard,
      { provide: MSAL_INSTANCE, useValue: msalInstance },
      { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
      { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
      { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    ]
  };

  const appRef = await bootstrapApplication(AppComponent, extendedConfig);

  const injector = appRef.injector;
  injector.get(O365AuthService).initialize();
}

main().catch(err => console.error(err));